import { RequirePermission } from "@/components/RequirePermission";
import { InvoiceTable } from "@/components/controller/InvoiceTable";

const Invoices = () => (
  <RequirePermission anyOf={["view_financials", "approve_invoices"]}>
    <div className="space-y-4">
      <h1 className="text-2xl font-bold tracking-tight">Invoice Management</h1>
      <InvoiceTable />
    </div>
  </RequirePermission>
);

export default Invoices;
